import { App } from "vue";
import CModal from "./modal";
import CTable from "./table";

import ModalPlugin, { hideModal } from "./modal/plugin";

export { ModalPlugin as Modal };

export * from "./modal/type";
export * from "./table/type";

/**
 * 隐藏所有Toast Modal Preview ActionSheet
 */
export const hideUI = function () {
  hideModal();
};

export default function install(app: App) {
  //注册组件
  app.component("CModal", CModal);
  app.component("CTable", CTable);

  // 引入插件
  app.use(ModalPlugin);
}
